import { render } from "./pc-item.vue?vue&type=template&id=a23ad83c&scoped=true&ts=true"
import script from "./pc-item.vue?vue&type=script&lang=ts"
export * from "./pc-item.vue?vue&type=script&lang=ts"

import "./pc-item.vue?vue&type=style&index=0&id=a23ad83c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a23ad83c"]])

export default __exports__